<template>
  <div>
    <Navbar />
    <section class="category-page">
      <Header
        formID="get-offer-health"
        :formData="formData"
        :insuranceType="insuranceType"
        approveRoute="tamamlayici-saglik-teklif-onay"
      />
      <get-quote :quoteCard="quoteCard" />
      <category-info :categoryInfo="categoryInfo" />
      <get-price-section :getPrice="getPrice" />

      <app-contracted-insurance-companies :buttons="buttonData" />
      <frequently-asked-questions
        :faqTitle="faqTitle"
        :faqTitleDesc="faqTitleDesc"
        :questions="questions"
      />
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/component/navbar/Navbar'
import Header from '@/component/categories/Header'
import GetQuote from '@/component/categories/GetQuote'
import categoryInfo from '@/component/categories/CategoryInfo'
import getPriceSection from '@/component/categories/GetPriceSection'
import appContractedInsuranceCompanies from '@/component/contracted-insurance-companies/AppContractedInsuranceCompanies'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import ComplementHealthInsuranceData from '@/data/category-page-data/ComplementHealthInsurance.js'
import Footer from '@/component/footer/Footer'
import QuotationType from '@/data/QuotationType'
import { filteredButtons } from '@/mixins/FilteredButtons'

export default {
  metaInfo: {
    title: 'En Uygun Tamamlayıcı Sağlık Sigortası Fiyatları',
    meta: [
      {
        name: 'description',
        content:
          'SGK tamamlayıcı sağlık sigortası yaptırın, tamamlayıcı sağlık sigortası anlaşmalı hastanelerinden kapsamlı hizmet alın. Tamamlayıcı sağlık sigortası hesaplama.'
      }
    ]
  },
  mixins: [filteredButtons],
  name: 'ComplementHealthInsurance',
  components: {
    Navbar,
    Header,
    GetQuote,
    categoryInfo,
    getPriceSection,
    appContractedInsuranceCompanies,
    frequentlyAskedQuestions,
    Footer
  },
  data () {
    return {
      insuranceType: QuotationType.COMPLEMENTARY,
      categoryInfo: ComplementHealthInsuranceData.categoryInfo,
      getPrice: ComplementHealthInsuranceData.getPrice,
      faqTitle: ComplementHealthInsuranceData.faqTitle,
      faqTitleDesc: ComplementHealthInsuranceData.faqTitleDesc,
      questions: ComplementHealthInsuranceData.questions,
      formData: {
        description: {
          upperText: 'En İyi',
          title: 'Tamamlayıcı Sağlık Sigortası Teklifi',
          bottomText: 'Sağlık Sigortası Fiyatlarını Karşılaştırın!'
        },
        button: 'TEKLİF AL',
        fullname: true,
        identity: true,
        phone: true,
        email: true
      },
      quoteCard: {
        title: 'İhtiyacınız Olan Tamamlayıcı Sağlık Sigortası Kapsamını Bulun!',
        description:
          'SGK anlaşmalı hastanelerde ihtiyacınız olan sağlık hizmetlerinden fark ücreti ödemeden yararlanın.',
        content: [
          {
            id: 1,
            icon: 'fas fa-file-alt',
            title: '10 Şirketten Tamamlayıcı Sağlık Sigortası',
            desc:
              'Planları karşılaştırırken göz önünde bulundurmanız gereken sağlık sigortasının önemli bir yönü, her bir şirketin sunduğu teminatlar ve anlaşmalı hastane ağ türüdür. '
          },
          {
            id: 2,
            icon: 'fab fa-cc-visa',
            title: 'Hızlı ve Kolay Fiyat',
            desc:
              'Sağlığınızı güvence altına alacak planı kolayca bulabilirsiniz. Uzman desteği ile sürecinizi minimuma indirerek, avantaj sağlayabilirsiniz.'
          },
          {
            id: 3,
            icon: 'fas fa-clipboard-check',
            title: 'Geniş Kapsamlı Poliçe ',
            desc:
              'Sağlık sigortası fiyatları, teminat aldığınız şirkete bağlı olarak değişecektir. Tamamlayıcı sağlık sigortası teminatlarını karşılaştırarak, en doğru poliçeyi seçebilirsiniz. '
          },
          {
            id: 4,
            icon: 'fas fa-users-cog',
            title: 'Online Sağlık Sigortası Avantajı',
            desc:
              'Tamamlayıcı sağlık sigortası ile sağlığınızı güvence altına almanıza yardımcı olmak için buradayız. Şimdi ücretsiz teklifinizi online alın!'
          }
        ]
      }
    }
  },
  mounted () {
    this.filterButtons('Tamamlayıcı Sağlık Sigortası')
  }
}
</script>
<style lang="scss">
@import '@/css/app.scss';
</style>
